import React, { useCallback, useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import Select from 'react-dropdown-select';
import { useSelector } from 'react-redux';
import { getRequest, postRequest } from '../../helpers/apiHandler';
import './_userRate.scss';

const CreateUserRateModal = ({ show, handleClose, setAlertState, getCreditData }) => {
  const { access_token } = useSelector((state) => state.auth.user);
  const [selectedUser, setSelectedUser] = useState('');
  const [selectedIso2, setSelectedIso2] = useState('MY');
  const [rate, setRate] = useState(0.0);
  const [loadingData, setLoadingData] = useState(false);
  const [users, setUsers] = useState([]);
  const [currencies, setCurrencies] = useState([]);

  const fetchData = useCallback(() => {
    setLoadingData(true);
    const data = { headers: { Authorization: access_token.token } };
    getRequest(`/admin/user-management`, data, (res) => {
      if (res.success) {
        const result = res.data;
        setUsers(result);
      } else {
        setAlertState({
          message: 'There was an issue while fetching user data',
          show: true,
          variant: 'danger',
        });
      }
      setLoadingData(false);
    });
  }, []);

  const resetValues = () => {
    setUsers([]);
    setRate(0.0);
    setSelectedUser('');
    setSelectedIso2('MY');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      email: selectedUser,
      rate: rate,
      iso2: selectedIso2,
    };
    postRequest('/admin/user-rates-create', data, access_token.token, (res) => {
      if (res.success) {
        setAlertState({
          show: true,
          variant: 'success',
          message: 'Successfully created!',
        });
      } else {
        setAlertState({
          show: true,
          variant: 'danger',
          message: res.message,
        });
      }
      getCreditData();
    });
    resetValues();
    handleClose();
  };

  const fetchCurrencies = useCallback(() => {
    const data = { headers: { Authorization: access_token.token } };
    getRequest(`/admin/user-rates-currencies`, data, (res) => {
      if (res.success) {
        const currencyOptions = res.data.map((currency) => ({
          value: currency.country_code,
          label: currency.country_name,
        }));
        setCurrencies(currencyOptions);
      } else {
        setAlertState({
          message: 'There was an issue while fetching currencies',
          show: true,
          variant: 'danger',
        });
      }
    });
  }, [access_token.token, setAlertState]);

  useEffect(() => {
    if (show) {
      fetchData();
      fetchCurrencies();
    }
  }, [show, fetchCurrencies]);

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Create User Rate</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="userSelect">
            <Form.Label>Select User</Form.Label>
            <Select
              value={selectedUser}
              multi={false}
              onChange={(e) => {
                const selected = e[0];
                setSelectedUser(selected.value);
              }}
              options={users.map((user) => ({
                value: user.email,
                label: `${user.name} (${user.email})`,
              }))}
            />
          </Form.Group>
          <Form.Group controlId="isoSelect2">
            <Form.Label>Select Country</Form.Label>
            <Select
              value={selectedIso2}
              multi={false}
              onChange={(e) => {
                const selected = e[0];
                setSelectedIso2(selected.value);
              }}
              options={currencies}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Rate</Form.Label>
            <Form.Control
              type="number"
              placeholder="Enter rate"
              step="0.001"
              min="0.0"
              value={rate}
              onChange={(e) => setRate(e.target.value)}
            />
          </Form.Group>
          <Button variant="primary" type="submit">
            Create
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateUserRateModal;
